<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <app-breadcrumb
                [title]="'Suivi des opérations'"
                [active_item]="'Journal Transactions'"
            ></app-breadcrumb>
            <div class="card">
                <div class="card-body">
                    <p-table
                        #dt
                        [value]="listNotifications"
                        [rows]="10"
                        [paginator]="true"
                        [globalFilterFields]="['created_at', 'nom']"
                        responsiveLayout="scroll"
                        [rowHover]="true"
                        dataKey="id"
                        currentPageReportTemplate="Affichage de {first} à {last} des {totalRecords}
              données"
                        [showCurrentPageReport]="true"
                        [globalFilterFields]="['event', 'action']"
                        responsiveLayout="scroll"
                        scrollable="true"
                        scrollHeight="flex"
                        width="100%"
                        class="responsive-claims-table"
                    >
                        <ng-template pTemplate="caption">
                            <div class="row">
                                <div class="col-md-3">
                                    <label class="block"
                                        ><b>Date début</b></label
                                    >
                                    <p-calendar
                                        [ngStyle]="{ width: '100%' }"
                                        [(ngModel)]="filterDateStart"
                                        [showIcon]="true"
                                        (ngModelChange)="
                                            changeDateStart($event)
                                        "
                                        [placeholder]="'JJ-MM-AAAA'"
                                        dateFormat="dd-mm-yy"
                                    ></p-calendar>
                                </div>
                                <div class="col-md-3">
                                    <label class="block"><b>Date fin</b></label>
                                    <p-calendar
                                        [ngStyle]="{ width: '100%' }"
                                        [(ngModel)]="filterDateEnd"
                                        [showIcon]="true"
                                        (ngModelChange)="changeDateEnd($event)"
                                        placeholder="JJ-MM-AAAA"
                                        dateFormat="dd-mm-yy"
                                    ></p-calendar>
                                </div>
                                <div class="col-md-3">
                                    <label class="block"
                                        ><b>Utilisateur </b></label
                                    >
                                    <p-dropdown
                                        [options]="listUsers"
                                        [(ngModel)]="selectedUser"
                                        optionLabel="fullName"
                                        [filter]="true"
                                        filterBy="nom"
                                        [showClear]="true"
                                        placeholder="Selectionner l'utilisateur"
                                    >
                                        <ng-template let-data pTemplate="item">
                                            <div class="country-item">
                                                <div>{{ data.fullName }}</div>
                                            </div>
                                        </ng-template>
                                    </p-dropdown>
                                </div>
                                <div class="col-md-1">
                                    <label style="opacity: 0"
                                        ><b></b>Actions</label
                                    >
                                    <p-button
                                        [style]="{ height: '60%' }"
                                        styleClass="p-button-success"
                                        icon="pi pi-filter"
                                        (click)="onFilter()"
                                        [disabled]="isFilter()"
                                    ></p-button>
                                </div>
                            </div>
                            <div
                                class="header-table mt-2"
                                style="
                                    display: flex;
                                    justify-content: space-between;
                                "
                            >
                                <div class="d-flex gap-3">
                                    <app-table-header
                                        [count]="listHistoriques"
                                        [legende]="'Journaux des transactions'"
                                    ></app-table-header>
                                    <button
                                        pButton
                                        pRipple
                                        label="Rafraîchir"
                                        (click)="OnRefresh()"
                                        icon="pi pi-refresh"
                                        class="p-button-secondary mt-3"
                                        style="height: max-content"
                                    ></button>
                                </div>
                                <div class="pt-3">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input
                                            pInputText
                                            type="text"
                                            (input)="
                                                dt.filterGlobal(
                                                    $event.target.value,
                                                    'contains'
                                                )
                                            "
                                            placeholder="Recherche"
                                        />
                                    </span>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th>#</th>
                                <th>Date</th>
                                <th class="text-center">Event</th>
                                <th class="text-center">Action</th>
                                <th class="text-center">
                                    Source [Utilisateur]
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template
                            let-i="rowIndex"
                            pTemplate="body"
                            let-historique
                        >
                            <tr>
                                <td class="text-center">{{ i + 1 }}</td>
                                <td class="text-center">
                                    {{
                                        historique?.created_at === null
                                            ? 'N/A'
                                            : historique?.created_at
                                    }}
                                </td>
                                <td class="text-center">
                                    {{ historique?.event ?? 'N/A' }}
                                </td>
                                <td class="text-center">
                                    {{ historique?.action ?? 'N/A' }}
                                </td>
                                <td class="text-center">
                                    {{ historique?.ip }} [{{
                                        historique?.user?.nom +
                                            ' ' +
                                            historique?.user?.prenoms
                                    }}]
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
    </div>
</div>
